module.exports = __webpack_public_path__ + "img/performa-logo.65b14083.svg";